import Select from "react-select";
import { useContext } from "react";
import { FormikContext } from "formik";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
 
const SelectField = ({
  label,
  name,
  options = [],
  value,
  error,
  clsname = "",
  searchable = false,
  placeholder = "Select...",
  isLoading = false,
  disabled = false,
  onChange,
  onBlur,
}) => {
  const formik = useContext(FormikContext);
 
  const resolvedValue =
    value !== undefined ? value : formik && name ? formik.values[name] : "";
 
  const setValue = (val) => {
    if (formik && name) {
      formik.setFieldValue(name, val);
    } else if (onChange) {
      onChange(val);
    }
  };
 
  const setTouched = () => {
    if (formik && name) {
      formik.setFieldTouched(name, true);
    } else if (onBlur) {
      onBlur();
    }
  };
 
  const formattedOptions = options.map((opt) =>
    typeof opt === "string" ? { value: opt, label: opt } : opt,
  );
 
  return (
    <div className="mb-2">
      {label && <label className={`form-label ${clsname}`}>{label}</label>}
 
      {searchable ? (
        <div style={{ position: "relative" }}>
          <Select
            options={formattedOptions}
            value={
              formattedOptions.find((o) => o.value === resolvedValue) || null
            }
            onChange={(opt) => setValue(opt ? opt.value : "")}
            onBlur={setTouched}
            placeholder={placeholder}
            isClearable
            isLoading={isLoading}
            isDisabled={disabled}
          />
 
          {error && (
            <ErrorOutlineIcon
              style={{
                position: "absolute",
                right: "34px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#dc3545",
                fontSize: "16px",
                pointerEvents: "none",
              }}
            />
          )}
        </div>
      ) : (
        <select
          className={`form-select custom-select-text ${error ? "is-invalid" : ""}`}
          style={{
            color: resolvedValue ? "#212529" : "#949ca4",
          }}
          value={resolvedValue || ""}
          onChange={(e) => setValue(e.target.value)}
          onBlur={setTouched}
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {formattedOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}
 
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};
 
export default SelectField;
 
 